import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import processControlTheme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Landing from './components/Landing';
import About from './components/About';
import Services from './components/Services';
import Suppliers from './components/Suppliers';
import ProcessControl from './components/ProcessControl';
import Products from './components/Products';
import VFDPanels from './components/VFDPanels';
import ChemicalStorageTanks from './components/ChemicalStorageTanks';
import CombinationStarterPanels from './components/CombinationStarterPanels';
import ElectricalControlProduct from './components/ElectricalControlProduct';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <ThemeProvider theme={processControlTheme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Navbar />
          <Box component="main" sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/vfd-panels" element={<VFDPanels />} />
              <Route path="/products/chemical-storage-tanks" element={<ChemicalStorageTanks />} />
              <Route path="/products/combination-starter-panels" element={<CombinationStarterPanels />} />
              <Route path="/products/electrical-control-product" element={<ElectricalControlProduct />} />
              <Route path="/process-control" element={<ProcessControl />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
